module.exports = __webpack_public_path__ + "img/user_logo.ea06c649.png";